import React from 'react';
import {
	rescheduleCall,
	setCancelReason,
} from '../../redux/myCourse/myCourse.actions';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';

const CancelFeedback = ({ setCancelReason, rescheduleCall, cancelReason }) => {
	return (
		<div class="modal" tabindex="-1" id="cancelCall" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<h4 className="modal-title">Reason for cancellation:</h4>
						</button>
					</div>
					<div class="modal-body">
						<textarea
							className="form-control"
							value={cancelReason}
							onChange={setCancelReason}
							rows="5"
							spellCheck="false"
							placeholder="Type your reason here."
						></textarea>
						<br />
						<div className="form-group text-right">
							<Button
								aria-label="submit"
								className="btn  btn-primary go-next"
								onClick={rescheduleCall}
							>
								Submit
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		cancelReason: state.rootReducer.myCourse.cancelReason,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		rescheduleCall: () => dispatch(rescheduleCall()),
		setCancelReason: (e) => dispatch(setCancelReason(e.target.value)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(CancelFeedback);
